'use strict';
/* global JS_AIRBRAKE_KEY, JS_AIRBRAKE_ID */

const AirbrakeClient = require('airbrake-js');
require('./../elm/style.scss');

const airbrake = new AirbrakeClient({
  projectId: JS_AIRBRAKE_ID,
  projectKey: JS_AIRBRAKE_KEY
});
airbrake.call(boot);

function boot () {
  window.MMM = window.MMM || {};

  window.MMM = require('./../elm/Journey/FieldMain.elm');
}


